export const FRACTION_DIGITS = {
  CORROSION_CLAS: 4,
};
